import {
  createActions,
  createReqReducer,
  createReqWatcher,
  createReqConsts,
  initialState as rootState,
} from '../../utils/redux/index';

export const consts = createReqConsts('complaints', 'details', [
  'RESET',
  'UPDATE',
]);
export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'complaint_notifications',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

const initialState = {
  ...rootState,
  data: undefined,
};

const defaultRequestReducer = createReqReducer(consts);

export default function(state = initialState, action) {
  switch (action.type) {
    case consts.SUCCEED: {
      return {
        ...state,
        ...rootState,
        succeed: true,
        data: action.payload,
      };
    }

    case consts.UPDATE: {
      return {
        ...state,
        data: action.payload,
      };
    }

    case consts.RESET: {
      return initialState;
    }

    default:
      return defaultRequestReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/redux/complaints/complaintDetails.js